export default __webpack_public_path__ + "static/media/icon-groupby.df6efdf7.svg";